import React from "react";

import HeroSection from "./ApiServicesHome/HeroSection";
import ServicesGrid from "./ApiServicesHome/ServicesGrid";
import WhyChooseUs from "./ApiServicesHome/WhyChooseUs";
import ProcessSection from "./ApiServicesHome/ProcessSection";
import FAQSection from "./ApiServicesHome/FAQSection";
import CTASection from "./ApiServicesHome/CTASection";

const ApiServicesHome = () => {
  return (
    <main className="w-full overflow-hidden bg-[#050505] text-white">
      {/* Hero */}
      <HeroSection />

      {/* API Services */}
      <ServicesGrid />

      {/* Why Choose Us */}
      <WhyChooseUs />

      {/* How It Works */}
      <ProcessSection />

      {/* FAQ */}
      <FAQSection />

      {/* CTA */}
      <CTASection />
    </main>
  );
};

export default ApiServicesHome;